import { createContext } from "react";

import { MeetingSidebarTabEnum } from "./meeting-sidebar/meeting-view-sidebar-constants";

type MeetingPageContextValueType = {
  activeSidebarTab?: MeetingSidebarTabEnum;
  setActiveSidebarTab?: (tab: MeetingSidebarTabEnum) => void;
  sidebarMeetingView?: "overview" | "load-previous-meeting" | number;
  setSidebarMeetingView?: (
    view: "overview" | "load-previous-meeting" | number,
  ) => void;
  onChangeMeetingView?: (
    meetingView: string,
    isReviewMeeting?: boolean | null,
  ) => void;
  isInSidebar: boolean;
  isInExtension: boolean;
};

export const MeetingPageContext = createContext<MeetingPageContextValueType>({
  activeSidebarTab: undefined,
  setActiveSidebarTab: undefined,
  sidebarMeetingView: undefined,
  setSidebarMeetingView: undefined,
  onChangeMeetingView: undefined,
  isInSidebar: false,
  isInExtension: false,
});
